import Index from '@/views/Settings/Information/Index.vue'
import Edit from '@/views/Settings/Information/Edit.vue'

export default {
  Index,
  Edit,
}
